module.exports = __webpack_public_path__ + "static/media/default-bg.4c0a52a1.jpg";